import ProcessTimeline from "../sections/ProcessTimeline";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const Process = () => {
    const ref = useReveal();
    return (
        <div ref={ref} data-testid="process-page" className="pt-24 md:pt-32">
            <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end reveal">
                    <div className="lg:col-span-8">
                        <p className="eyebrow mb-6">The Method</p>
                        <h1
                            className="font-display text-samora-ink leading-[0.95] tracking-tight"
                            style={{ fontSize: "clamp(2.75rem, 7vw, 7rem)" }}
                        >
                            How a Samora<br />
                            <span className="italic font-serif text-samora-gold">
                                home is made.
                            </span>
                        </h1>
                    </div>
                    <p className="lg:col-span-4 text-samora-text/75 text-lg leading-relaxed">
                        Every home follows the same eight-step method — a
                        studio discipline built over a decade of watching what
                        goes right, and what quietly goes wrong.
                    </p>
                </div>
            </section>

            <ProcessTimeline />

            <section className="py-24 md:py-32 bg-samora-ink text-samora-bone">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 text-center">
                    <p className="eyebrow text-samora-gold mb-6">
                        Ready to begin?
                    </p>
                    <h2
                        className="font-display leading-[0.95] tracking-tight max-w-3xl mx-auto"
                        style={{ fontSize: "clamp(2.25rem, 5vw, 5rem)" }}
                    >
                        Step one is a 30-minute conversation.
                    </h2>
                    <Link
                        to="/contact"
                        data-testid="process-cta"
                        className="btn-samora bg-samora-bone text-samora-ink border-samora-bone hover:bg-samora-gold hover:text-white hover:border-samora-gold mt-10"
                    >
                        Book Discovery Call <ArrowRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Process;
